import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useIdentitySwapWindow } from '~/hooks/useIdentitySwapWindow';
import { useSwapAuthToken } from '~/hooks/useSwapAuthToken';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
const loaderName = 'switch-business';
export const prevBusinessIdKey = 'prevBusinessId';
export function useSwitchBusiness() {
    const navigate = useNavigate();
    const { t: commonTexts } = useLocaleKeys('common');
    const { startLoader, stopLoader, showErrorToast } = useOverlayContext();
    const { getState } = useStoreStatic();
    const { api, logBI } = useStoreActions();
    const { localStorage } = useIoContext();
    const swapAuthToken = useSwapAuthToken();
    const { beginIdentitySwap, abandonIdentitySwap } = useIdentitySwapWindow();
    async function switchBusiness(businessId) {
        let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const showFailureToast = ()=>showErrorToast(commonTexts.toasts.failedToSwitchBusiness(), 'switch-business-failure');
        if (!businessId) {
            showFailureToast();
            navigate(routes.logout);
            return;
        }
        const prevBusinessId = selectors.user.businessId(getState());
        startLoader(loaderName);
        beginIdentitySwap();
        try {
            const authToken = await handlePromise(api.user.switchBusiness(businessId));
            logBI(10354);
            if (authToken.data) {
                prevBusinessId && localStorage.setItem(prevBusinessIdKey, prevBusinessId);
                Sentry.addBreadcrumb({
                    type: 'switchBusiness',
                    data: {
                        businessId,
                        prevBusinessId
                    }
                });
                await swapAuthToken(authToken.data, {
                    route: options.newRoute
                });
            } else {
                showFailureToast();
                abandonIdentitySwap();
            }
        } catch (error) {
            Sentry.captureException(error);
            showFailureToast();
            abandonIdentitySwap();
        } finally{
            stopLoader(loaderName);
        }
    }
    return {
        switchBusiness
    };
}
